import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import * as constants from 'helper/constants';
import strings from 'helper/localization/localization';

export default class LoginForm extends PureComponent {
  constructor(props) {
    super(props);

    // Properties
    this.api = this.props.api;
    this.updateUser = this.props.updateUser;
    this.successAlert = this.props.successAlert;
    this.handleSuccessfulLogin = this.props.handleSuccessfulLogin;
    this.loginAttrs = { email: '', password: '' };

    // State
    this.state = {
      loginError: false,
      loginBtnClass: 'btn-outline-primary',
    };
  }

  setLoginReady = () => {
    this.setState({
      loginBtnClass: this.loginAttrs.email && this.loginAttrs.password
        ? 'btn-primary' : 'btn-outline-primary',
    });
  }

  emailChanged = (event) => {
    this.loginAttrs.email = event.target.value;
    this.setLoginReady();
  }

  passwordChanged = (event) => {
    this.loginAttrs.password = event.target.value;
    this.setLoginReady();
  }

  login = async (event) => {
    event.preventDefault();

    const { email, password } = this.loginAttrs;
    const loginResponse = await this.api.login(email, password);

    if (loginResponse.status === constants.api.success) {
      this.api.token = loginResponse.res.body.access_token;
      const fetchUserDetailsResponse = await this.api.fetchUserDetails();
      if (fetchUserDetailsResponse.status === constants.api.success) {
        const userDetails = fetchUserDetailsResponse.res.body;
        this.updateUser(userDetails);
      }

      this.setState({ loginError: await this.handleSuccessfulLogin(loginResponse.res.body) });
    } else {
      this.setState({ loginError: true });
    }
  }

  render() {
    return (
      <div className="container login--form">
        {this.state.loginError ? (
          <div className="alert alert-danger alert-dismissible fade show" role="alert">
            {strings.loginError}
            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">{'\u00D7'}</span>
            </button>
          </div>
        ) : ''}

        {this.successAlert ? (
          <div className="alert alert-success alert-dismissible fade show" role="alert">
            {this.successAlert}
            <button type="button" className="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">{'\u00D7'}</span>
            </button>
          </div>
        ) : ''}

        <div className="row">
          <div className="col">
            <h1>{strings.loginToYourAccount}</h1>
          </div>
        </div>

        <form>
          <div className="form-group">
            <label htmlFor="login--email">{strings.emailAddress}</label>
            <input type="email" className="form-control" onChange={this.emailChanged} id="login--email" />
          </div>

          <div className="form-group">
            <label htmlFor="login--password">{strings.password}</label>
            <input type="password" className="form-control" onChange={this.passwordChanged} id="login--password" />
          </div>

          <div className="form-group text-right">
            <Link to="/login/forgot-password" className="forgotten-password-link text-body">
              {strings.forgottenYourPassword}
            </Link>
          </div>

          <button
            type="submit"
            className={`btn btn-lg btn-block ${this.state.loginBtnClass}`}
            id="button--login"
            onClick={this.login}
          >
            {strings.login}
          </button>

          <Link
            to="/signup"
            id="button--signup"
            className="btn btn-lg btn-block btn-link"
          >
            {strings.signup}
          </Link>
        </form>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/login/LoginForm.jsx